import { render } from "./alternative-item.vue?vue&type=template&id=595688d1&scoped=true&ts=true"
import script from "./alternative-item.ts?vue&type=script&lang=ts&external"
export * from "./alternative-item.ts?vue&type=script&lang=ts&external"

import "./alternative-item.scss?vue&type=style&index=0&id=595688d1&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595688d1"]])

export default __exports__